import * as models from '@daas-consulting/production/age_groups/frontend/models';
import { Observable } from 'rxjs';

export interface AgeGroupsService {
  getAll$(): Observable<models.list.ItemView[]>;
}

export const AgeGroupsServiceId = 'AgeGroupsServiceId';
